import { defineStore } from 'pinia'
import { sendApi } from '@/utils/api'
import { PAY_URL } from '@/config';
import { packagesList } from '@/composables/packagesList';
const pack = packagesList()
function dataRender (data){
  return data.map(item => ({
    id:item.id,
    address:item.address,
    package_id:item.package_id,
    package_name:item.package_name,
    package_description:item.package_description,
    package_price:item.package_price,
    package_total:item.package_total,
    package_count:item.package_count,
    factor:item.factor,
    status:item.status,
    status_tahvil:item.status_tahvil,
    created_at:item.created_at,
    updated_at:item.updated_at,
  }));
}
export const useFactorStore = defineStore('factor', {
  state: () => ({
    cards: [],
    hasMore: false,
    isLoaded: false,
    requestFactorUrl:''
  }),
  actions: {
    async fetchFactors (limit = 10, offset = 0, append = false) {
      try{
        const res = await sendApi({
          action: 'get_factors',
          control: 'product',
          data: { limit, offset }
        })
        if (res.status === 'success') {
          const newproducts = dataRender(res.data);
          const filteredproducts = newproducts.filter(product => product.id)
          if(append){
            this.cards = [...this.cards, ...filteredproducts]
          }
          this.isLoaded = true
          this.hasMore = res.has_more ?? false
          return filteredproducts
        }
        return []
      } catch (err) {
        console.log(err);
      }
    },
    async addResponse (data) {
      try{
        const res = await sendApi({
          action: 'add_factor_response',
          control: 'product',
          data: data
        })
        return res.status === 'success'
      } catch (err) {
        console.log(err);
      }
    },
    async addFactorReturnId (data) {
      try{
        const res = await sendApi({
          action: 'add_factor_return_id',
          control: 'product',
          data: data
        })
        return (res.status === 'success'?(parseInt(res.id)>0?parseInt(res.id):0):0) 
      } catch (err) {
        console.log(err);
      }
    },
    selectPackageWhereId(id){
       return pack.filter((v)=>v.id == id)[0]
    },
    sendFactorRquest(){
        window.open(PAY_URL+this.requestFactorUrl,'','')
        // window.location.replace(PAY_URL+this.requestFactorUrl);
    },
    pay(packId,factorId,user) {
        const selected=this.selectPackageWhereId(packId)
        let des='';
        for (let i = 0; i < selected.details.length; i++) {
            des+= (selected.details[i].t>0?selected.details[i].t+' عدد سفته '+
            (selected.details[i].m==1000?
                ' یک میلیارد تومانی':
                (selected.details[i].m==2000?
                    ' دو میلیارد تومانی':
                    selected.details[i].m+' میلیون تومانی'
                )
            ):'');
        }
        this.requestFactorUrl='?factorId='+parseInt(factorId)+
        '&packId='+packId+
        '&price='+selected.price+
        '&mobile='+user.mobile+
        '&name='+user.name+
        '&family='+user.family+
        '&packName='+selected.title+
        '&packDescription='+selected.description+
        '&packDes='+des;
        return this.sendFactorRquest()
    }
}})